import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Switch,
  Modal,
  Dimensions,
} from "react-native";
import { Text, View } from "../../../components/Themed";
import { jsonToCSV } from "react-native-csv";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { RootStackScreenProps } from "../../../types";
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/AntDesign";
import { useFocusEffect } from "@react-navigation/native";
import { postData } from "../../../networking/api";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { ActivityIndicator } from "react-native";

import { TextInput } from "react-native-paper";
import IconCross from "react-native-vector-icons/Entypo";
import IconEdit from "react-native-vector-icons/FontAwesome";

import IconEye from "react-native-vector-icons/Entypo";
import { color } from "react-native-elements/dist/helpers";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function SubZoneProfile({ navigation }) {
  const [text, setText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  var [counter, setCounter] = useState(1);
  const [projectId, setProjectId] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [SubZoneDataLength, setSubZoneDataLength] = useState(0);
  const [SubZoneNameData, setSubZoneNameData] = useState([]);
  const [subZoneListExport, setSubZoneListExport] = useState([]);
  const [isExportLoading, setIsExportLoading] = useState(true);

  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [isSubZoneNameDataValid, setSubZoneNameDataValid] = useState(false);
  const [isSubZoneNameDataEntered, setSubZoneNameDataEntered] = useState(false);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  var idProject = useSelector((state) => state.idUpdating);


  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          textTransform: "Capitalize",
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.sub_zone_name.toLowerCase();
    const b = rowB.sub_zone_name.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row) => row.index,

      width: "100px",
    },
    {
      name: "Zone",
      selector: (row) =>
        row.zone_master == null ? null : row.zone_master.zone_name,
      sortable: true,
    },
    {
      name: "Sub Zone",
      selector: (row) => row.sub_zone_name,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Code",
      selector: (row) => row.sub_zone_code,
      sortable: true,
    },
    {
      name: "Omega Name",



      selector: (row) =>
        row.sub_zone_devices.length > 0
          ? row.sub_zone_devices[0].devices_master === null
            ? "NA"
            : row.sub_zone_devices[0].devices_master.device_name
          : "NA",

      sortable: true,
    },
    {
      name: "Action",
      width: "100px",

      cell: (item) => (
        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity
            style={{ marginRight: 10 }}
            onPress={() => {
              navigation.navigate("EditSubzoneProfile", { SubZoneId: item.id });
            }}
          >
            <IconEdit
              name="pencil"
              size={13}
              color="#fff"
              style={{
                padding: 6,
                backgroundColor: "#08588E",
                borderRadius: 12,
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              navigation.navigate("ViewSubzoneProfile", { SubZoneId: item.id });
            }}
            style={{ marginRight: 10 }}
          >
            <IconEye
              name="eye"
              size={13}
              color="#fff"
              style={{
                padding: 6,
                backgroundColor: "#08588E",
                borderRadius: 12,
              }}
            />
          </TouchableOpacity>
        </View>
      ),
    },
    {
      name: "Status",
      width: "100px",

      cell: (item, index) => (
        <Switch
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
  ];

  const toggleSwitch = () => {
    var tempIndex = SubZoneNameData.findIndex((item) => item.id === popid);

    if (SubZoneNameData[tempIndex].active == 1) {
      SubZoneNameData[tempIndex].active = 0;
      activeSubZone(popid, 0);
    } else {
      SubZoneNameData[tempIndex].active = 1;
      activeSubZone(popid, 1);
    }
    setSubZoneNameData(SubZoneNameData);
  };
  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, SubZoneDataLength);
  React.useEffect(() => {
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();
      searchFilterFunction("");
    }, []),
  );
  useEffect(() => {
    getAdminData();
  }, [idProject]);
  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getAllSubZoneProfileData([], projValue);
      getSubzoneListForExport(projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);

      getAllSubZoneProfileData([], userDetailsresponse.project_selected);
      getSubzoneListForExport(userDetailsresponse.project_selected);
    }
  };

  const searchFilterFunction = (text) => {
    if (text) {
      const newData = SubZoneNameData.filter(function (item) {
        const itemData = item.sub_zone_name
          ? item.sub_zone_name.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(SubZoneNameData);
      setSearch(text);
      setPage(0);
    }
  };
  const activeSubZone = async (cityId, isActive) => {
    setIsLoading(true);
    try {
      var SubZoneData = JSON.stringify({
        id: cityId,
        module: "sub_zone_master",
        data: {
          active: isActive,
        },
      });
      const activeSubZoneResponse = await postData(
        SubZoneData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = activeSubZoneResponse.code;
      if (code == 1) {
        setIsVisible(false);
        getAllSubZoneProfileData([], projectId);
        getSubzoneListForExport(projectId);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const exportCsvSubZoneData = async () => {
    setIsLoading(true);
    try {
      var getSubZoneData = JSON.stringify({
        module: "sub_zone_master",
      });
      const SubZoneNameResponse = await postData(
        getSubZoneData,
        "masters/exportFile",
      );
      setIsLoading(false);
      var code = SubZoneNameResponse.code;
      if (code == 1) {
        setSubZoneNameData(SubZoneNameResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getAllSubZoneProfileData = async (sortdata: never[], pid) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setSubZoneDataLength(sortdata.length);
      setSubZoneNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var getSubZoneData = JSON.stringify({



          condition: {
            project_id: pid,
          },
          module: "sub_zone_master",
          relation: [
            {
              module: "sub_zone_devices",
              subModule: "devices_master",
            },
            {
              module: "zone_master",
            },
          ],
        });
        const SubZoneNameResponse = await postData(
          getSubZoneData,
          "masters/getMasterList",
        );
        setIsLoading(false);
        var code = SubZoneNameResponse.code;
        if (code == 1) {
          setSubZoneDataLength(SubZoneNameResponse.data.length);
          setSubZoneNameData(SubZoneNameResponse.data);
          setFilteredDataSource(SubZoneNameResponse.data);
          const results = jsonToCSV(SubZoneNameResponse.data);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error", error);
      }
    }
  };
  const sortFun = () => {
    const sortData = filterData.sort((item, b) =>
      sort == 1
        ? item.sub_zone_name.localeCompare(b.sub_zone_name)
        : b.sub_zone_name.localeCompare(item.sub_zone_name),
    );
    getAllSubZoneProfileData(sortData);
    setFilteredDataSource(sortData);
  };

  const getSubzoneListForExport = async (pid) => {
    setIsExportLoading(true);
    try {
      var stateData = JSON.stringify({
        modelName: "sub_zone_master",
        project_id: pid,
      });
      const deviceDataResponse = await postData(
        stateData,
        "masters/dependentListExport",
      );
      setIsExportLoading(false);
      var code = deviceDataResponse.code;
      if (code == 1) {
        setSubZoneListExport(deviceDataResponse.data);
      } else {
        setIsExportLoading(false);
      }
    } catch (error) {
      setIsExportLoading(false);
      console.error("Error", error);
    }
  };

  const downloadExcelReport = async () => {
    const filteredData = subZoneListExport.map(
      ({ zone_name, sub_zone_name, sub_zone_code, omega, active }, index) => ({
        "Sr No": index + 1,
        Zone: zone_name,
        "Sub Zone": sub_zone_name,
        Code: sub_zone_code,
        "Omega Name": omega,
        Active: active == 1 ? "Active" : "InActive",
      }),
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelData, "subzone.xlsx");
  };

  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  return (
    <View style={styles.container}>
      <View
        style={
          isMobile
            ? { width: "100%", marginTop: 270 }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View
          style={
            isMobile
              ? { margin: 10, marginTop: -45, height: 0, flex: 1 }
              : { flex: 1, margin: 10 }
          }
        >
          <Text style={isMobile ? [styles.lableText] : [styles.lableText]}>
            Profile {">"} SubZone/Group
          </Text>
        </View>
        <Modal
          visible={editpopup}
          animationType={"slide"}
          transparent={true}
          onRequestClose={() => {
            setEditPopup(false);
          }}
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "white",
                    borderColor: "#eee",
                    borderRadius: 5,
                    alignSelf: "center",
                    borderWidth: 1,
                    height: "25%",
                    margin: "auto",
                    padding: 10,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    width: "60%",
                  }
                : [styles.contanerSwitch]
            }
          >
            <TouchableOpacity
              style={{ alignSelf: "flex-end" }}
              onPress={() => setEditPopup(false)}
            >
              <IconCross
                name="circle-with-cross"
                size={20}
                color="#000"
                style={{ bottom: 5, top: 0 }}
              />
            </TouchableOpacity>

            <Text style={[styles.tableHead, { marginBottom: 20 }]}>
              Do You Want Update Status
            </Text>
            <View
              style={{
                flexDirection: "row",
                paddingRight: 10,
                justifyContent: "space-between",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  (setEditPopup(false), toggleSwitch());
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>Yes</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setEditPopup(false);
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>No</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>

        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  marginTop: 20,
                  marginLeft: "-35%",
                  width: "170%",
                  flex: 2,
                }
              : { alignItems: "center", flex: 2 }
          }
        >
          <TextInput
            style={
              isMobile
                ? {
                    height: 35,
                    borderWidth: 2,
                    paddingLeft: 10,
                    borderColor: "#319ef0",
                    backgroundColor: "#FFFFFF",
                    width: "50%",
                    borderRadius: 5,
                    color: "#000",
                    fontWeight: "400",
                  }
                : styles.textInputStyle
            }
            onChangeText={(text) => searchFilterFunction(text)}
            value={searchData}
            underlineColorAndroid="transparent"
            underlineColor={"white"}
            placeholder="Search Sub Zone"
            theme={{
              colors: {
                text: "black",
                primary: "white",
                background: "transparent",
              },
            }}
            left={
              <TextInput.Icon
                name={() => <IconEdit name="search" size={20} color="#000" />}
              />
            }
          />
        </View>

        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <TouchableOpacity
            style={
              isMobile
                ? {
                    alignItems: "center",
                    backgroundColor: "#006EB9",
                    padding: 10,
                    borderWidth: 1,
                    borderColor: "#006EB9",
                    width: "35%",
                  }
                : styles.addDevice
            }
            onPress={() => {
              navigation.navigate("CreateSubzoneProfile");
            }}
          >
            <Text style={styles.btnText}>
              <Icon name="plus" size={15} color="#fff" /> Create
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <View
        style={
          isMobile
            ? {
                width: "100%",
                alignItems: "flex-end",
                marginTop: "-9%",
                marginLeft: "-120%",
              }
            : { width: "100%", alignItems: "flex-end" }
        }
      >
        <TouchableOpacity
          style={
            isMobile
              ? {
                  alignItems: "center",
                  backgroundColor: "#006EB9",
                  padding: 10,
                  borderWidth: 1,
                  borderColor: "#006EB9",
                  width: "45%",
                  marginRight: -10,
                }
              : {
                  alignItems: "center",
                  backgroundColor: "#006EB9",
                  padding: 10,
                  borderWidth: 1,
                  borderColor: "#006EB9",
                  width: "10%",
                }
          }
          onPress={() => {
            downloadExcelReport();
          }}
        >
          <Text style={styles.btnText}>
            <Icon name="exclefile1" size={15} color="#fff" /> Download
          </Text>
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <View style={{ flex: 1 }}></View>
      </View>

      <View
        style={
          isMobile
            ? [styles.card, { flexGrow: 1, marginTop: 50, paddingBottom: 10 }]
            : [styles.card, { flexGrow: 1 }]
        }
      >
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
              paddingVertical: 0,
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "130%",
                      alignSelf: "center",
                    }
                  : {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "100%",
                      alignSelf: "center",
                    }
              }
            >
              <View>
                {isLoading || isExportLoading ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoading || isExportLoading}
                    textContent={"Loading..."}
                    size={80}
                  />
                ) : (
                  <DataTable
                    columns={columns}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                  />
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  input: {
    borderColor: "gray",
    width: "60%",
    borderWidth: 1,
    borderRadius: 10,

    padding: 10,
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
    color: "#000000",
  },
  addDevice: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  card: {
    width: "80%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 10,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "37%",
    borderRadius: 5,
    color: "#000",
    fontWeight: "400",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
});
